export default {
  HOME: "HOME",
  DATAVIEW: "DATAVIEW",
  DATAVIEWADMIN: "DATAVIEWADMIN",
  ABOUT: "ABOUT",
  FILES: "FILES"
};
